// 📂 utils/redirect.js
export function setRedirect(nav, side) {
  localStorage.setItem(
    "admin-redirect",
    JSON.stringify({
      nav,
      side,
    })
  );
}

export function getRedirect() {
  const redirectState = localStorage.getItem("admin-redirect");
  if (!redirectState) return null;
  try {
    return JSON.parse(redirectState);
  } catch {
    return null;
  }
}

export function clearRedirect() {
  localStorage.removeItem("admin-redirect");
}
